import {mapValues} from 'lodash';
import {flow, get, identity, isFunction} from 'lodash/fp';
import {convert as convertReduce} from 'lodash/fp/reduce';
import {createStructuredSelector} from 'reselect';

const uncappedReduce = convertReduce({cap: false});

export const withProps =
  (moreProps: any) => (selector: any) => (state: any, ownProps: any) =>
    selector(state, {
      ...ownProps,
      ...uncappedReduce((result: any, value: any, name: any) => {
        return {
          ...result,
          [name]: isFunction(value) ? value(state, ownProps) : value,
        };
      }, {})(moreProps),
    });

export const fromProps = (selector: any) => (_: any, props: any) =>
  selector(props);

export const createStructuredScreenSelector =
  ({
    selectorMap,
    defaultScreenName,
    otherSelectors = {},
    effect = identity,
  }: any) =>
  (st: any, {screenName = defaultScreenName}) => {
    const sharedSelectors = mapValues(otherSelectors, flow(effect));
    const screenSelectors = mapValues(
      selectorMap,
      flow(get(screenName), effect),
    );

    return createStructuredSelector({
      ...screenSelectors,
      ...sharedSelectors,
      // @ts-expect-error TS(2345): Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
    })(st);
  };
